<template>
  <div>
    <div v-for="(ot, index) in ots" :key="index"
         class="border-color-select border-bottom-horizontal-none">
      <div class="columns mg-auto">
        <div class="column columns is-marginless is-multiline">
          <div class="has-text-weight-bold ellipsis has-text-link
          column is-3 is-paddingless">
            <router-link-blank v-if="ot.id"
                               :to="{ name: 'c.logistique.ordre_travail-tech',
                                      params: { id: ot.id } }"
                               class-message="is-size-7"
                               :message="getLibelleTypeIntervention(ot.typeOtId)">
            </router-link-blank>
          </div>
          <div class="column is-3 is-paddingless is-size-7 mgt-3px is-italic">
            <b-tooltip :label="ot.ville"
                       class="width-100percent"
                       multiline
                       v-if="ot.ville"
                       position="is-left">
              <div class="ellipsis">
                {{ ot.ville }}
              </div>
            </b-tooltip>
          </div>
          <div class="ellipsis has-text-link column is-6 is-paddingless
          has-text-right is-size-7 mgt-3px">
            {{ ot.code }} - {{ getLibelleEtat(ot.etat) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { LIST_ETAT_OT_TECH } from '@/configuration/logistique/ordreTravail/ordreTravailConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ots: {
      required: true,
      type: Array,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getLibelleTypeIntervention(typeOtId) {
      const typeFind = this.parametre(PARAMETRES_KEYS.typeOt).find((type) => {
        return type.id === typeOtId;
      });
      return typeFind ? typeFind.libelle : null;
    },
    getLibelleEtat(etatOt) {
      const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
        return etat.code === etatOt;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
